/**
 * Captcha Module
 * reCAPTCHA utilities
 */

/**
 * Executes reCAPTCHA for the given component.
 * Returns true if captcha was executed, false otherwise.
 */
export function runCaptcha(componentId: string | null): boolean {
    if (!componentId) {
        return false;
    }

    const captcha = document.querySelector(`#g-recaptcha${componentId}div`);

    if (captcha && typeof grecaptcha !== 'undefined') {
        const widgetId = captcha.getAttribute('opt_widget_id');

        if (widgetId) {
            grecaptcha.execute(widgetId);
            
            return true;
        }
    }

    return false;
}

export function resetCaptcha(componentId: string | null): void {
    if (!componentId) {
        return;
    }

    const captcha = document.querySelector(`#g-recaptcha${componentId}div`);

    if (captcha && typeof grecaptcha !== 'undefined') {
        const widgetId = captcha.getAttribute('opt_widget_id');
        
        if (widgetId) {
            grecaptcha.reset(widgetId);
        }
    }
}